import { render, staticRenderFns } from "./co-to-jest-banka-spekulacyjna.md?vue&type=template&id=711c7518&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports